import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  header: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  accommodationDetailsContainer: {
    width: '100%',
    display: 'flex',
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 12,
    marginBottom: 30,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  switchContainerForMapping: {
    width: '25%',
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    }
  },
  SwitchWithText: {
    position: 'relative',
    bottom: 16,
    [theme.breakpoints.down('xs')]: {
      top: 0,
      right: 'calc(50% - 154px)',
      marginBottom: 16,
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }
    // marginBottom: 16
  },
  switchContainer: {
    width: '40%',
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left'
    }
  },
  switchContainerForRateplan: {
    marginLeft: 385,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      width: '100%',
      marginTop: 10
    }
  },
  switch: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
    // backgroundColor: 'green'
  },
  switchForRatePlanToRight: {
    // background: 'blue',
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
      // marginLeft: 250
    }
  },
  noDataContainer: {
    width: '100%',
    height: '400px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
